import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { compatWrapper } from '@backstage/core-compat-api';
import announcementsPlugin from '@backstage-community/plugin-announcements/alpha';
import { AnnouncementsPage } from '@backstage-community/plugin-announcements';

// The page:announcements extension is overridden for two reasons:
//
// 1. `hideInactive` — the plugin's page extension config schema only accepts
//    `path`; props like `hideInactive` cannot be set via app-config.yaml and
//    must be passed directly to the component here.
//
// 2. `compatWrapper` — AnnouncementsPage still depends on MUI v4 and legacy
//    Backstage React contexts. The wrapper bridges those until the plugin ships
//    a native new-frontend-system implementation.
const announcementsPageOverride = announcementsPlugin
  .getExtension('page:announcements')
  .override({
    params: {
      path: '/announcements',
      loader: async () => compatWrapper(<AnnouncementsPage hideInactive />),
    },
  });

export const announcementsModule = createFrontendModule({
  pluginId: 'announcements',
  extensions: [announcementsPageOverride],
});
